import { UrlItem } from '@core/abstractions/url-item';

export const urlWhiteList: UrlItem[] = [
  { url: '/api/v1/securityfileimports/', method: 'GET' },
  { url: '/api/v1/countrytaxnewsfileimports/', method: 'GET' },
];
